import { useBaseProps } from '@hoc/withBaseProps';
import * as React from 'react';
import S from './PopupWrapper.styles';
const PopupWrapper = React.forwardRef((props, ref) => {
    const { children, showPopup = false, ...otherProps } = props;
    const baseProps = useBaseProps();
    if (!showPopup) {
        return null;
    }
    return (React.createElement(S.Container, { ref: ref, id: baseProps.id, ...otherProps }, children));
});
PopupWrapper.displayName = 'PopupWrapper';
export default PopupWrapper;
